
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.685.557h-22.4a2.247 2.247 0 00-2.24 2.24v22.4a2.247 2.247 0 002.24 2.24h22.4a2.247 2.247 0 002.24-2.24v-22.4a2.247 2.247 0 00-2.24-2.24z","fill":"#034752"}}),_c('path',{attrs:{"d":"M11.805 11.309l3.08-4.48c.56-.84 1.344-1.288 2.24-1.288.728 0 1.4.28 1.96.784.56.56.84 1.176.84 1.904 0 .56-.168 1.008-.448 1.456l-2.8 4.032 3.416 4.312c.336.448.504.952.504 1.512 0 .784-.28 1.4-.784 1.96-.56.56-1.176.84-1.96.84-.84 0-1.456-.28-1.904-.84l-4.144-5.096v2.856c0 .84-.168 1.456-.448 1.904-.504.84-1.288 1.232-2.24 1.232-.896 0-1.568-.28-2.072-.896-.448-.56-.672-1.288-.672-2.24V8.621c0-.896.224-1.568.728-2.184.504-.616 1.176-.896 2.016-.896.84 0 1.512.28 2.072.896.28.336.504.672.56 1.008.056.224.056.616.056 1.176v2.688z","fill":"#fff"}})])
          )
        }
      }
    